/**
 * Content registry. Everything the engine needs to know about authored content
 * is re-exported here so that systems import from a single, stable module.
 */

export * from './schema';
export { CAREER_FIELDS, CAREER_FIELD_LIST } from './careers';
export { EDUCATION_PROGRAMS, EDUCATION_PROGRAM_LIST, CREDENTIAL_LABELS } from './education';
export {
  ASSET_CLASSES,
  ASSET_CLASS_LIST,
  MARKET_REGIMES,
  BUSINESS_ARCHETYPES,
  BUSINESS_ARCHETYPE_LIST,
} from './economy';
export { ASPIRATIONS, ASPIRATION_DEF_LIST } from './aspirations';
export {
  ORIGINS,
  ORIGIN_DEF_LIST,
  MOTIVATIONS,
  MOTIVATION_DEF_LIST,
  ARCHETYPES,
  ARCHETYPE_DEF_LIST,
} from './identity';
export { BOARD_SEGMENTS } from './board-segments';
export { ALL_EVENTS, EVENTS_BY_ID, EVENTS_BY_POOL } from './events';
export { FIRST_NAMES, SURNAMES, CHILD_NAMES, PLAYER_NAME_SUGGESTIONS } from './names';

/** Bumped whenever authored content changes in a way that affects balance. */
export const CONTENT_VERSION = '1.0.0';
